// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { getPublicationListFailed, getPublicationListRequested, getPublicationListSucceeded } from './select-publication.actions';
import { PublicationListResponse } from '@par/app/core/model/dictionaries.response';

export const STATE_NAME_SELECT_PUBLICATION = 'select-publication';

export interface State {
  response?: PublicationListResponse;
  responseError: boolean;
  responseLoading: boolean;
}

const initialState: State = {
  response: undefined,
  responseError: false,
  responseLoading: false,
};

const reducer = createReducer(
  initialState,
  on(getPublicationListRequested, (state) => (
    state.response != null
      ? state
      : {...state, responseLoading: true, responseError: false}
  )),
  on(getPublicationListSucceeded, (state, {response}) => ({
    ...state,
    responseLoading: false,
    response,
    responseError: false,
  })),
  on(getPublicationListFailed, (state) => ({...state, responseLoading: false, responseError: true})),
);

export function selectPublicationReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}

